<div kendoDialogContainer></div>
